var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"srcdoc":_vm.srcdoc,"loading":"eager","allowfullscreen":"true","allow":"","frameborder":"0"},on:{"load":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }